import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon, CalendarDaysIcon, NotebookPenIcon } from 'lucide-react';
const items = [{
  icon: BookIcon,
  title: 'Guía Completa',
  value: '$37'
}, {
  icon: CalendarDaysIcon,
  title: 'Plan 21 Días',
  value: '$27'
}, {
  icon: NotebookPenIcon,
  title: 'Diario de Bienestar',
  value: '$17'
}];
export function WhatYouGet() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-197">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-199">
          <h2 className="text-4xl lg:text-5xl font-bold text-[var(--color-charcoal)] text-center mb-16" data-id="element-200">
            Tu inversión en bienestar
          </h2>

          <div className="bg-[var(--color-cream)] rounded-3xl p-8 lg:p-12 shadow-sm border border-[var(--color-pale-pink)]" data-id="element-201">
            <div className="space-y-6 mb-10" data-id="element-202">
              {items.map((item, i) => <div key={i} className="flex items-center justify-between pb-6 border-b border-[var(--color-pale-pink)] last:border-0 last:pb-0" data-id="element-203">
                  <div className="flex items-center gap-4" data-id="element-204">
                    <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-205">
                      <item.icon className="w-6 h-6 text-[var(--color-sage)]" strokeWidth={1.5} data-id="element-206" />
                    </div>
                    <span className="text-lg lg:text-xl font-medium text-[var(--color-charcoal)]" data-id="element-207">
                      {item.title}
                    </span>
                  </div>
                  <span className="text-lg text-[var(--color-charcoal)] opacity-60" data-id="element-208">
                    {item.value}
                  </span>
                </div>)}
            </div>

            <div className="bg-white rounded-2xl p-8 text-center shadow-sm" data-id="element-209">
              <p className="text-lg text-[var(--color-charcoal)] opacity-70 mb-2" data-id="element-210">
                Valor total: <span className="line-through" data-id="element-211">$81</span>
              </p>
              <p className="text-4xl lg:text-5xl font-bold text-[var(--color-charcoal)]" data-id="element-212">
                Precio hoy: $8.49
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}